<template>
    <div v-if="post" class="left">
        <div class="na-form">

            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">ID:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.EptId' :readOnly="true" />
                    </div>
                    <!--<div class="udc-description">
                        <div class="udc-field-required">*</div>
                        <div class="udc-field-description">xxxx</div>
                    </div>-->
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Runde:</div>
                    <div class="dx-field-value">
                        <DxSelectBox displayExpr="RouName" :dataSource="roundList" valueExpr="RouId" v-model:value="post.RouId">
                        </DxSelectBox>
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Rundentyp:</div>
                    <div class="dx-field-value">
                        <DxSelectBox displayExpr="RtyName" :dataSource="roundTypeList" :showClearButton='true' valueExpr="RtyId" v-model:value="post.RtyId">
                        </DxSelectBox>
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Name:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.EptName' />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Begin der Runde:</div>
                    <div class="dx-field-value">
                        <DxDateBox v-model:value='post.EptStartRoundOn' />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Ende der Runde:</div>
                    <div class="dx-field-value">
                        <DxDateBox v-model:value='post.EptEndRoundOn' />
                    </div>

                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Changed on:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.EptChangedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Changed by:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.EptChangedBy' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Created on:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.EptCreatedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Created by:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.EptCreatedBy' :readOnly="true" />
                    </div>
                </div>
                <div class="na-buttons-row">

                    <div>
                        <DxButton text="Close"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick()" />
                    </div>
                    <div class="btnBlock">
                        <DxButton text="Save"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onSaveClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>


                </div>


            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    // @ is an alias to /src

    import { DxTextBox/*, DxTextArea*/ } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import '../assets/detailForm.less';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/ExpertTypeService";
    export default {
        name: 'ExpertTypeDetail',
        components: {

            DxButton,
            DxTextBox
            /*       DxTextArea*/,
            DxDateBox,
            DxSelectBox
        },
        data() {
            return {
                post: null,
            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetail')
                .then(res => {
                    this.post = res.data.data

                })
        },
        computed: {
            roundList() {
                return this.$store.state.roundStore.roundList
            },
            roundTypeList() {
                return this.$store.state.roundTypeStore.roundTypeList
            }
        },
        mounted: function (){
            this.$store.dispatch("getRoundList", {})
            this.$store.dispatch("getRoundTypeList", {})
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                var formData = new FormData()
                formData.append("data", JSON.stringify(this.post))
                axios
                    .post(baseUri + '/SaveDetail', formData)
                    .then(res => {
                        if (res.data.success) { notify(`The changes were saved successfully`); }
                        else { alert(`error: ${res.data.errorMessage}`) }

                    })

            },
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>
</style>
